import { IState } from '../../../store';

export const selectOfferCategory = (state: IState) => state.offerData.offer.category;
